var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ALoading.vue?vue&type=custom&index=0&blockType=div&ref=loading&class=%0A%20%20%20%20%20%20%20%20%20%20fixed%0A%20%20%20%20%20%20%20%20%20%20inset-0%0A%20%20%20%20%20%20%20%20%20%20z-50%0A%20%20%20%20%20%20%20%20%20%20flex%0A%20%20%20%20%20%20%20%20%20%20items-center%0A%20%20%20%20%20%20%20%20%20%20justify-center%0A%20%20%20%20%20%20%20%20%20%20text-2xl%0A%20%20%20%20%20%20%20%20%20%20font-semibold%0A%20%20%20%20%20%20%20%20%20%20text-white%0A%20%20%20%20%20%20%20%20%20%20bg-primary-800%0A%20%20%20%20%20%20%20%20"
if (typeof block0 === 'function') block0(component)

export default component.exports